<template>
  <div class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3" style="margin-left: 10px; margin-top: 80px;">
      <div class="col-md-12 no-job-dispaly">
          <!-- <i class="fa fa-frown-o" aria-hidden="true"></i> -->
          {{ "You don't have Access to this page"}}
      </div>
  </div>
</template>
<script>
export default {
  name: 'NotAllowed',
  data() {
    return {};
  }
}
</script>
<style scoped>
</style>